// Typelizer digest 9f42fe48d59f4657b09716637c409ff9
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** DELETE /c/:company_id/ledger/payments/:payment_id/verification */
  destroy: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/ledger/payments/:payment_id/verification', params, options),
    method: 'delete',
  }),

  /** POST /c/:company_id/ledger/payments/:payment_id/verification */
  create: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/payments/:payment_id/verification', params, options),
    method: 'post',
  }),
}
